export const SEND_MONEY = 'sendMoney';
export const SEND_REQUEST = 'sendRequest';
export const MERCHANT_TYPE = 'business';
export const PERSONAL_TYPE = 'personal';
export const PENDING_REQUEST = 'pendingRequest';
export const FULFILL_REQUEST = 'fulfillRequest';

export type SendRequestTabs = typeof SEND_MONEY | typeof SEND_REQUEST | typeof PENDING_REQUEST;

export interface SendAndRequest {
    currentTab: SendRequestTabs;
}

export interface AnnouncementData {
    imgUrl: string | null;
    eventId: number;
    firstName: string;
    lastName: string;
    type: string;
    username: string;
}

export interface Announcement {
    id: number;
    title: string;
    message: string;
    data: AnnouncementData;
    createDate: string;
    read: boolean;
}

export interface AnnouncementState {
    data: Announcement[];
    loading: boolean;
    error: boolean;
}
export interface AnnouncementDetailState {
    details: Announcement | null;
    loading: boolean;
    error: boolean;
}
